export default function prepareWelds(welds) {
  let newArr = []
  welds.map(o => newArr.push({
    ...o,
    wps: o.wps,
    weld_type: o.weld_joint_type, // Zachowujemy oryginalne dane z GraphQL dla formattera
    inspection_category: o.inspection_category && o.inspection_category.id,
    inspections: JSON.parse(o.inspections),
    failed_inspections: o.failed_inspections ? JSON.parse(o.failed_inspections) : {},
    inspection_groups: o.inspection_groups ? JSON.parse(o.inspection_groups) : {},
    ...JSON.parse(o.extra_data),
    element: o.project.name,
    actions: {save: false}
  }))

  return newArr
}



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/WeldsDataGridPrepareWelds.js